export default __webpack_public_path__ + "static/media/l_wdt_c_2.9ba2382a.mp3";